import { X as CloseIcon } from "@tamagui/lucide-icons";
import type { GetProps } from "tamagui";

import { Button } from "./Button";

/**
 * Shared close (X) button used by both the right sidebar and modal hosts.
 * Renders an accessible button; the host decides what closing means via `onClose`.
 */
const CloseButton = ({
  onClose,
  ...props
}: {
  onClose: () => void;
} & GetProps<typeof Button.Wrapper>) => {
  return (
    <Button.Wrapper
      aria-label="Close"
      alignSelf="flex-end"
      onPress={onClose}
      {...props}
    >
      <CloseIcon size={24} />
    </Button.Wrapper>
  );
};

export default CloseButton;
